<app-project-submenu></app-project-submenu>
<p-confirm-dialog />
<p-dialog
  [(visible)]="websiteAutoUpdateDialogVisible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '28rem' }"
  (onHide)="closeWebsiteAutoUpdateDialog()"
>
  <ng-template pTemplate="header">
    <span i18n="@@enable-website-auto-update">Automatisches Neuladen aktivieren</span>
  </ng-template>
  <div class="d-flex flex-column gap-2">
    <label
      for="website-auto-update-interval"
      i18n="@@website-auto-update-interval"
    >Alle X Tage automatisch neu laden</label>
    <input
      id="website-auto-update-interval"
      type="number"
      min="1"
      max="365"
      pInputText
      [value]="websiteAutoUpdateIntervalInput"
      (input)="websiteAutoUpdateIntervalInput = $any($event.target).value"
    />
    @if(websiteAutoUpdateIntervalError) {
    <small class="text-danger">{{ websiteAutoUpdateIntervalError }}</small>
    }
  </div>
  <ng-template pTemplate="footer">
    <p-button
      label="Abbrechen"
      i18n-label="@@cancel"
      severity="secondary"
      [outlined]="true"
      (click)="closeWebsiteAutoUpdateDialog()"
    />
    <p-button
      label="Automatisches Neuladen aktivieren"
      i18n-label="@@enable-website-auto-update"
      (click)="saveWebsiteAutoUpdateConfig()"
    />
  </ng-template>
</p-dialog>
<ng-template #newBtn>
  <p-fileupload
    #fileupload
    name="file"
    mode="basic"
    maxFileSize="100000000"
    [chooseIcon]="fileupload.uploading ? 'ri-loader-2-line spinning-icon' : 'ri-add-line'"
    [url]="projectDocumentsService.uploadEndpoint"
    [accept]="fileUploadService.allowedFileTypes.join(',')"
    (onUpload)=" projectDocumentsService.fileUploadDone($event)"
    (onError)="this.uploadError($event)"
    (onBeforeUpload)="  projectDocumentsService.addFormFieldsForUpload($event)"
    [auto]="true"
    [chooseStyleClass]="projectDocuments.length === 0 ? 'p-button-primary' : 'p-button-secondary'"
    [disabled]="fileupload.uploading"
    [chooseLabel]="this.getNewBtnLabel(fileupload.uploading, fileupload.progress)"
  />
  @if(this.sharePointService.isSharepointAvailable){
  <app-sharepoint-button (fileSelected)="projectDocumentsService.reloadDocuments()"></app-sharepoint-button>
  }
  <app-website-button (fileSelected)="projectDocumentsService.reloadDocuments()"></app-website-button>
</ng-template>

@if (projectDocuments.length > 0) {
<div class="d-flex justify-content-between align-items-center mb-2 mt-3">
  <div class="d-flex gap-2 align-items-start">
    <ng-container [ngTemplateOutlet]="newBtn"></ng-container>
  </div>
  <p-iconfield>
    <p-inputicon class="ri ri-search-line" />
    <input
      pInputText
      type="text"
      #filterInput
      [disabled]="bulkBusy"
      (input)="selectedDocuments = []; dt.filterGlobal(filterInput.value, 'contains')"
      i18n-placeholder="@@search-placeholder"
      placeholder="Suchen..."
    />
  </p-iconfield>
</div>
}
@if (bulkFailedNames) {
<p class="bot-bulk-error" role="alert"><span i18n="@@doc-bulk-failed">Folgende Dokumente konnten nicht gelöscht werden. Versuche es erneut:</span> {{bulkFailedNames}}</p>
}
<p-table
  #dt
  dataKey="_id"
  [(selection)]="selectedDocuments"
  sortField="uploadDate"
  [sortOrder]="-1"
  [globalFilterFields]="['filename', 'usedIn.botName']"
  [value]="projectDocuments"
  [rowHover]="projectDocuments.length > 0"
>
  <ng-template #header>
    @if (projectDocuments.length > 0) {
    <tr>
      <th class="bot-selection-cell"><p-tableHeaderCheckbox [disabled]="bulkBusy"
        ariaLabel="Alle angezeigten Dokumente auswählen" i18n-ariaLabel="@@doc-select-all" /></th>
      <th style="min-width: 82px;"></th>
      <th
        [noWrap]="true"
        style="min-width: 250px; display: flex; align-items: center;"
      >
        <span pSortableColumn="filename">
          <ng-container i18n="@@name">Name</ng-container>
          <p-sortIcon
            field="filename"
            style="margin-left: 5px;"
          />
        </span>
      </th>
      <th style="width: 100%;">
        <ng-container i18n="@@used-in">Bot-Zugriff</ng-container>
      </th>
      <th
        [noWrap]="true"
        style="min-width: 141px;"
      >
        <span pSortableColumn="uploadDate">
          <ng-container i18n="@@last-change">Aktualisiert</ng-container>
          <p-sortIcon
            field="uploadDate"
            style="margin-left: 5px;"
          />
        </span>
      </th>
      <th style="width: 72px;"></th>
    </tr>
    }
  </ng-template>

  <ng-template
    #body
    let-doc
  >
    <tr>
      <td class="bot-selection-cell" style="vertical-align: top;"><p-tableCheckbox [value]="doc" [disabled]="bulkBusy"
        [ariaLabel]="doc.filename" /></td>
      <td
        style="width: 1px; vertical-align: top;"
        [pTooltip]="doc.mimetype"
        tooltipPosition="right"
      >
        <i
          style="width: 80px; margin-right: 12px; margin-left: 13px;"
          class="ri {{ getMimeTypeIcon(doc.mimetype) }} ri-xl"
        ></i>
      </td>
      <td
        style="vertical-align: top;"
        class="name-cell"
      >
        <span
          class="fakelink"
          [pTooltip]="doc.filename"
          tooltipPosition="top"
          (click)="openDocumentDetail(doc)"
        >{{ doc.filename }}</span>
        @if(doc.source?.type === 'sharepoint-file' || doc.source?.type === 'sharepoint-page') {
        <div class="text-muted text-small mt-1">
          <span i18n="@@sharepoint-auto-update-status">Automatisches Neuladen:</span>
          @if(doc.autoUpdate?.enabled) {
          <span i18n="@@auto-update-on">an</span>
          } @else {
          <span i18n="@@auto-update-off">aus</span>
          }
          @if(doc.autoUpdate?.disabledReason === 'source_deleted') {
          <span
            class="ms-1"
            i18n="@@sharepoint-source-deleted"
          >(Quelle in SharePoint gelöscht)</span>
          }
        </div>
        }
        @if(doc.source?.type === 'website') {
        <div class="text-muted text-small mt-1">
          <span i18n="@@website-auto-update-status">Automatisches Neuladen:</span>
          @if(doc.autoUpdate?.enabled) {
          <span i18n="@@auto-update-on">an</span>
          } @else {
          <span i18n="@@auto-update-off">aus</span>
          }
          @if(doc.autoUpdate?.enabled && doc.autoUpdate?.intervalDays) {
          <span class="ms-1">(alle {{ doc.autoUpdate?.intervalDays }} Tage)</span>
          }
        </div>
        }
        @if(doc.extractionStatus === 'uploaded' && !doc.mimetype?.startsWith('image/')) {
        <div class="mt-1 d-flex align-items-center gap-1">
          <p-tag
            severity="warn"
            i18n="@@extraction-status-not-read"
            pTooltip="Dieses Dokument wurde von der KI noch nicht eingelesen. Starten Sie die Extraktion, um es für die KI-Suche verfügbar zu machen."
            i18n-pTooltip="@@extraction-status-uploaded-hint"
            tooltipPosition="right"
          >
            <i class="ri-information-line"></i>
            Nicht eingelesen
          </p-tag>
          <p-button
            class="text-secondary"
            icon="ri-ai-generate-text"
            [rounded]="true"
            size="small"
            severity="secondary"
            pTooltip="Extraktion konfigurieren"
            i18n-pTooltip="@@extraction-configure"
            tooltipPosition="right"
            (click)="openExtractionDialog(doc)"
          />
        </div>
        }
        @if(doc.extractionStatus === 'extracting') {
        <div class="mt-1"><p-tag
            severity="info"
            value="Wird extrahiert…"
            i18n-value="@@extraction-status-extracting"
          /></div>
        }
        @if(doc.extractionStatus === 'failed') {
        <div class="mt-1"><p-tag
            severity="danger"
            value="Extraktion fehlgeschlagen"
            i18n-value="@@extraction-status-failed"
            [pTooltip]="getExtractionErrorTypeHint(doc.extractionErrorType)"
            tooltipPosition="right"
          /></div>
        }
      </td>
      <td>
        <ul>
          @for (usage of doc.usedIn; track $index) {
          <li><a
              class="href-muted"
              [routerLink]="['/bot-admin', usage.botId, 'documents']"
            >{{usage.botName}}</a>
            @if(usage.projectId !== doc.projectId) {
            <span
              class="text-muted text-small"
              i18n="@@from-project"
            >
              <br>
              Aus Projekt mit ID:
              {{usage.projectId}}</span>
            }
          </li>
          }
        </ul>
      </td>
      <td
        style="vertical-align: top;"
        [noWrap]="true"
      >
        <div>
          <span class="text-muted">{{ dayjs(doc.uploadDate).fromNow() }}</span>
          <br>
          <span class="text-muted">{{ doc.uploadedBy }}</span>
        </div>
      </td>
      <td style="vertical-align: top;">
        <p-popover
          [dismissable]="true"
          #popover
          appendTo="body"
        >
          <div class="flex flex-column">
            @for (item of contextMenu; track item) {
            <div
              class="flex align-items-center gap-3 py-1 px-2 cursor-pointer popover-hover transition-colors transition-duration-150"
              (click)="item.command(); popover.hide()"
            >
              <i
                [class]="item.icon"
                class="text-secondary me-3"
              ></i>
              <span class="text-color">{{ item.label }}</span>
            </div>
            }
          </div>
        </p-popover>
        <p-button
          #button
          (click)="openMenu($event, popover, doc, button) "
          [rounded]="true"
          severity="secondary"
          styleClass="button-icon"
          icon="ri ri-more-2-fill"
        />
        <span class="d-none">
          <p-fileupload
            [id]="'fileReplace-'+doc._id"
            #fileReplace
            mode="basic"
            name="file"
            chooseIcon="ri-upload-line"
            [url]="projectDocumentsService.replaceEndpoint"
            [accept]="fileUploadService.allowedFileTypes.join(',')"
            maxFileSize="100000000"
            (onUpload)="projectDocumentsService.onReplaceDone($event)"
            (onBeforeUpload)="projectDocumentsService.addFormFieldsForReplace($event, doc._id)"
            [auto]="true"
            chooseLabel="Dokument ersetzen"
            i18n-chooseLabel="@@replace-document"
          />
        </span>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td
        colspan="6"
        class="text-center p-5 text-muted"
      >
        @if (this.projectDocuments.length === 0) {
        <ng-container i18n="@@no-documents">
          Noch keine Dokumente vorhanden. Lade dein erstes Dokument hoch.
        </ng-container>
        }
        @if (this.projectDocuments.length > 0) {
        <ng-container i18n="@@no-documents-filtered">
          Keine Dokumente gefunden. Passe deine Suche an.
        </ng-container>
        }
        <br><br>

        <div class="text-center d-flex flex-column gap-2">
          <ng-container [ngTemplateOutlet]="newBtn"></ng-container>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
<app-bulk-action-bar [actions]="bulkActions" [count]="selectedDocuments.length" [busy]="bulkBusy"
  [allSelected]="selectedDocuments.length === (dt.filteredValue ?? projectDocuments).length"
  (selectAll)="selectedDocuments = (dt.filteredValue ?? projectDocuments).slice()" (clear)="selectedDocuments = []" />

<app-extraction-dialog
  [(visible)]="extractionDialogVisible"
  [doc]="extractionDialogDoc"
  (extracted)="onExtractionDone()"
/>

@if (detailDrawer) {
<p-drawer
  [(visible)]="detailDrawer"
  [position]="'right'"
  [modal]="true"
  [closeOnEscape]="true"
  styleClass="w-100 w-md-75 w-lg-50"
>
  @if (selectedDoc) {
  <app-project-document-detail
    [doc]="selectedDoc"
    [chunks]="selectedDocChunks"
    [chunksLoading]="chunksLoading"
  ></app-project-document-detail>
  }
</p-drawer>
}